import { render, staticRenderFns } from "./StaffProfileForm.vue?vue&type=template&id=7ee32173&"
import script from "./StaffProfileForm.vue?vue&type=script&lang=js&"
export * from "./StaffProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports